import { captureRecruitmentContext } from '~/utils/recruitmentContext'
import { isTeamAssessmentRoute } from '~/utils/assessmentInvitation'
import { reportWorkflowError } from '~/utils/workflowErrorReporting'

export default async function({
	app,
	$axios,
	$config,
	route,
	store,
	error,
	redirect
}) {
	if (!isTeamAssessmentRoute(route)) return
	const isCurrent = captureRecruitmentContext(store.state)
	try {
		const context = await $axios.$get(
			`/job-offer/${route.params.id}/assessment-context`,
			{ __skipGlobalErrorToast: true }
		)
		if (!isCurrent()) return
		if (
			String(store.state.user?.user?.current_organization?.id) !==
			String(context.organization_id)
		) {
			const user = await $axios.$get(
				`user/change-organization/${context.organization_id}`,
				{ __skipGlobalErrorToast: true }
			)
			if (!isCurrent()) return
			await store.dispatch('user/setUser', user)
			store.commit(
				'organization/setOrganization',
				user.current_organization
			)
		}
		if (!$config?.featureFlags?.teamAssessments || context.retake_locked) {
			return redirect(`/job-offer/${route.params.id}/view/work-style`)
		}
	} catch (requestError) {
		if (!isCurrent()) return
		const statusCode = requestError?.response?.status || 500
		reportWorkflowError(requestError, {
			flow: 'job_offer_assessment',
			operation: 'load_team_assessment_context',
			jobOfferId: route.params.id,
			rootState: store.state,
			teamAssessmentMode: true
		})
		return error({
			statusCode,
			message: app.i18n.t(
				`error.${
					[403, 404].includes(statusCode) ? statusCode : 500
				}.message`
			)
		})
	}
}
